import { useContainer } from '../../useContainer';
import { AbsenceReportApi } from '../../../api';

const useHttpTriggerAbsenceCompute = () => {
    const absenceReportApi: AbsenceReportApi = useContainer(AbsenceReportApi);

    const trigger = (onSuccess?: () => void, onError?: () => void) => {
        const { exec } = absenceReportApi.triggerCompute({
            onSuccess,
            onError,
        });
        exec();
    };

    return { trigger };
};

export default useHttpTriggerAbsenceCompute;
